// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SeparatorContract = contract({
  name: "Separator",
  description: "Light divider between sibling blocks in a Card, list, or header. For section-level partition use extra spacing instead.",
  import: "@gradeui/ui",
  aliases: ["divider","rule","hr","line","horizontal rule"],
  element: "div",
  composesWith: ["Card (between CardHeader/Content/Footer)","navigation menus","any vertical stacks"],
  styleDefaults: {"Separator":"shrink-0 bg-border"},
  props: {
  "orientation": {
      schema: z.enum(["horizontal", "vertical"]).optional(),
      design: "knob",
      description: "default \"horizontal\"",
  },
  "decorative": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide from a11y tree",
      default: true,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
